<template>
    <div class="c-doc-link-home">
        <LayoutContent>
            <div class="c-doc-link-box">
                <div class="c-link-item">
                    <a href="https://docs.qq.com/pdf/DV3pET2RIdXpqTEh1" target="_blank" class="link-item-a"></a>
                    <div class="item-inner">
                        <p class="cd-item-header">
                            <span class="header-icon">
                                <i class="c-inner-icon icon-01"></i>
                            </span>
                            <span class="header-text">{{ $t("main:产品文档") }}</span>
                        </p>
                        <p class="cd-item-detail">{{ $t("main:查看游戏语音GVoice所有相关文档") }}</p>
                    </div>
                </div>
                <div class="c-link-item">
                    <a href="javascript:;" class="link-item-a"></a>
                    <div class="item-inner">
                        <p class="cd-item-header">
                            <span class="header-icon"> <i class="c-inner-icon icon-02"></i></span>
                            <span class="header-text">{{ $t("main:常见问题") }}</span>
                        </p>
                        <p class="cd-item-detail">{{ $t("main:自助解决产品常见疑问") }}</p>
                    </div>
                </div>
                <div class="c-link-item">
                    <a href="javascript:;" class="link-item-a"></a>
                    <div class="item-inner">
                        <p class="cd-item-header">
                            <span class="header-icon"> <i class="c-inner-icon icon-03"></i></span>
                            <span class="header-text">{{ $t("main:快速接入") }}</span>
                        </p>
                        <p class="cd-item-detail">{{ $t("main:了解游戏语音GVoice重要功能与操作步骤") }}</p>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "DocLinkHome",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-doc-link-home {
    padding: 0 24px;
    background-color: #151829;
}
.c-doc-link-box {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    padding-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.cd-item-header {
    display: flex;
    align-items: center;
    color: #fff;
    & + .cd-item-detail {
        margin-top: 14px;
    }
    .header-icon {
        & + .header-text {
            margin-left: 16px;
        }
    }
    .header-text {
        font-size: 22px;
        line-height: 1;
    }
}
.cd-item-detail {
    font-size: 16px;
    color: #999;
}
.c-link-item {
    flex: 1;
    display: flex;
    align-items: center;
    min-height: 178px;
    padding: 24px;
    border: 2px solid #1d243f;
    border-radius: 16px;
    background-color: #060c24;
    position: relative;
    overflow: hidden;
    &:hover {
        background-color: #04091d;
        .cd-item-header {
            .header-text {
                color: @primary-color;
            }
        }
    }
    & + .c-link-item {
        margin-left: 30px;
    }
    .item-inner {
        padding-bottom: 32px;
    }
    .link-item-a {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
}
.c-doc-link-box {
    display: flex;
}
.c-inner-icon {
    display: inline-block;
    &.icon-01 {
        width: 50px;
        height: 44px;
        background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/doc-link-icon-01.png) no-repeat center center;
        background-size: cover;
    }
    &.icon-02 {
        width: 54px;
        height: 46px;
        background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/doc-link-icon-02.png) no-repeat center center;
        background-size: cover;
    }
    &.icon-03 {
        width: 54px;
        height: 45px;
        background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/doc-link-icon-03.png) no-repeat center center;
        background-size: cover;
    }
}
@media only screen and (max-width: 1200px) {
    .c-doc-link-box {
        min-height: 240px;
    }
    .c-link-item {
        min-height: 144px;
        & + .c-link-item {
            margin-left: 16px;
        }
    }
    .c-inner-icon {
        &.icon-01 {
            width: 40px;
            height: 35px;
        }
        &.icon-02 {
            width: 40px;
            height: 34px;
        }
        &.icon-03 {
            width: 40px;
            height: 34px;
        }
    }
    .cd-item-header {
        & + .cd-item-detail {
            margin-top: 8px;
        }
        .header-text {
            font-size: 18px;
        }
    }
    .cd-item-detail {
        font-size: 14px;
    }
}
@media only screen and (max-width: 995px) {
    .c-doc-link-box {
        min-height: 160px;
    }
    .c-link-item {
        min-height: 120px;
        padding: 16px 24px;
        & + .c-link-item {
            margin-left: 16px;
        }
    }
    .c-inner-icon {
        &.icon-01 {
            width: 40px;
            height: 35px;
        }
        &.icon-02 {
            width: 40px;
            height: 34px;
        }
        &.icon-03 {
            width: 40px;
            height: 34px;
        }
    }
    .cd-item-header {
        & + .cd-item-detail {
            margin-top: 8px;
        }
        .header-text {
            font-size: 18px;
        }
    }
    .cd-item-detail {
        font-size: 14px;
    }
}
@media only screen and (max-width: 768px) {
    .c-doc-link-box {
        flex-direction: column;
    }
    .c-link-item {
        width: 100%;
        & + .c-link-item {
            margin-left: 0;
            margin-top: 8px;
        }
    }
}
</style>
